import { createSelector } from 'reselect';
import { AppState } from '~/store';

/**
 * If maxProcessesInWorkspace is null then expected to have unlimited processes in workspace
 */
export const canAddProcess = createSelector(
  (state: AppState, props: { maxProcessesInWorkspace?: number }) => props.maxProcessesInWorkspace,
  (state: AppState) => state.workspaceResources.processes.allIds,
  (maxProcessesInWorkspace, processes) =>
    maxProcessesInWorkspace
      ? processes.length < maxProcessesInWorkspace
      : maxProcessesInWorkspace === null,
);

export const canAddActivityTemplate = createSelector(
  (state: AppState, props: { maxActivityTemplatesInWorkspace?: number }) =>
    props.maxActivityTemplatesInWorkspace,
  (state: AppState) => state.workspaceResources.activities.allIds,
  (maxActivityTemplates, activities) =>
    maxActivityTemplates ? activities.length < maxActivityTemplates : false,
);

export const canAddActivityToProcess = createSelector(
  (state: AppState, props: { maxActivitiesInProcess?: number }) => props.maxActivitiesInProcess,
  (state: AppState) => state.workspaceResources.activities.allIds,
  (maxActivitiesInProcess, activities) =>
    maxActivitiesInProcess ? activities.length < maxActivitiesInProcess : false,
);

export const canAddActivityToWorkspace = createSelector(
  (state: AppState, props: { maxActivitiesInWorkspace?: number }) => props.maxActivitiesInWorkspace,
  (state: AppState) => state.workspaceResources.activities.allIds,
  (maxActivitiesInWorkspace, activities) =>
    maxActivitiesInWorkspace ? activities.length < maxActivitiesInWorkspace : false,
);

export const canAddApiKey = createSelector(
  (state: AppState) => state.userResources.users.current.limit_overrides.maxAccessCredentials,
  (state: AppState) => state.userResources.personalApiKeys.allIds,
  (maxApiKeys, apiKeys) => (maxApiKeys ? apiKeys.length < maxApiKeys : false),
);

export const canCreateOrganization = createSelector(
  (state: AppState) => state.userResources.users.current.limit_overrides.maxOrganizations,
  (state: AppState) => state.userResources.users.current.current_limited?.createdOrganizations,
  (maxOrganizations, createdOrganizations) =>
    maxOrganizations && typeof createdOrganizations === 'number'
      ? createdOrganizations < maxOrganizations
      : false,
);

export const canAddSecret = createSelector(
  (state: AppState, props: { maxSecretsInWorkspace?: number }) => props.maxSecretsInWorkspace,
  (state: AppState) => state.workspaceResources.secrets.allNames,
  (maxSecrets, secrets) => (maxSecrets ? secrets.length < maxSecrets : false),
);

export const selectCurrentOrganizationId = (state: AppState) => state.ui.currentOrganizationId;
export const selectCurrentWorkspaceId = (state: AppState) => state.ui.currentWorkspaceId;
